(() => {
  const root = document.querySelector('.jootti-field-guide[data-fg-full="public-v1"]');
  if (!root) return;
  const view = document.getElementById('jootti-field-guide-view');
  const params = new URLSearchParams(location.search);
  const productionRoutes = root.dataset.fgRouteMode === 'production';
  const screen = productionRoutes
    ? (root.dataset.fgScreen === 'family' && params.get('fg') === 'catalog' ? 'catalog' : root.dataset.fgScreen || 'landing')
    : params.get('fg') || root.dataset.fgScreen || 'landing';
  const assetMap = JSON.parse(document.getElementById('jootti-field-guide-asset-map').textContent);
  const publish = (name, properties = {}) => {
    try { window.Shopify?.analytics?.publish?.(name, {guide: 'megabass', ...properties}); } catch (_) { /* Analytics must never interrupt the guide. */ }
  };
  const h = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };
  const append = (parent, ...children) => { children.filter(Boolean).forEach(child => parent.append(child)); return parent; };
  const route = (name, extra = {}) => {
    let url;
    if (productionRoutes) {
      const path = {
        landing: '/pages/megabass-field-guide',
        family: extra.family ? `/pages/megabass-guide-family/${encodeURIComponent(extra.family)}` : '/pages/megabass-field-guide-families',
        entry: extra.entry ? `/pages/megabass-guide-entry/${encodeURIComponent(extra.entry)}` : '/pages/megabass-field-guide-families',
        pathway: extra.pathway ? `/pages/megabass-guide-pathway/${encodeURIComponent(extra.pathway)}` : '/pages/megabass-field-guide',
        comparison: extra.comparison ? `/pages/megabass-guide-compare/${encodeURIComponent(extra.comparison)}` : '/pages/megabass-field-guide',
        choose: '/pages/megabass-field-guide-choose',
        search: '/pages/megabass-field-guide-search',
        catalog: '/pages/megabass-field-guide-families',
      }[name] || '/pages/megabass-field-guide';
      url = new URL(path, location.origin);
      if (name === 'catalog') url.searchParams.set('fg', 'catalog');
      if (extra.q) url.searchParams.set('q', extra.q);
    } else {
      url = new URL(root.dataset.fgRoot, location.origin);
      url.searchParams.set('fg', name);
      for (const [key, value] of Object.entries(extra)) url.searchParams.set(key, value);
    }
    const preview = params.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search;
  };
  root.querySelectorAll('a[href*="view=jootti-megabass-field-guide"]').forEach(anchor => {
    const url = new URL(anchor.href, location.origin);
    const extra = Object.fromEntries([...url.searchParams].filter(([key]) => !['fg', 'view', 'preview_theme_id'].includes(key)));
    anchor.href = route(url.searchParams.get('fg') || 'landing', extra);
  });
  root.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    if (anchor.classList.contains('jootti-field-guide__commerce-link')) {
      publish('field_guide_product_click', {entry_handle: params.get('entry') || '', product_id: anchor.dataset.productId || ''});
      return;
    }
  });
  publish('field_guide_open', {screen});
  if (screen === 'landing') return;
  view.replaceChildren(append(h('section', 'jootti-field-guide__page-intro'), h('p', 'jootti-field-guide__subtle', 'Opening the guide…')));

  const image = (item, size = 'result', eager = false) => {
    const figure = h('figure', `jootti-field-guide__product-study jootti-field-guide__product-study--${size}`);
    const source = item.image?.url || assetMap[item.image?.asset];
    if (source) {
      const img = h('img');
      img.src = source;
      img.alt = item.alt || item.name || 'Fishing lure';
      img.loading = eager ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.width = 1200;
      img.height = 900;
      append(figure, img);
    } else {
      append(figure, h('span', 'jootti-field-guide__image-fallback', item.name || 'Guide entry'));
    }
    return figure;
  };
  const eyebrow = text => h('p', 'jootti-field-guide__eyebrow', text);
  const link = (label, name, extra = {}, cls = 'jootti-field-guide__inline-link') => {
    const a = h('a', cls, label);
    a.href = route(name, extra);
    return a;
  };
  const intro = (kicker, title, description) => append(h('section', 'jootti-field-guide__page-intro'), eyebrow(kicker), h('h1', '', title), description && h('p', 'jootti-field-guide__subtle', description));
  const empty = message => h('p', 'jootti-field-guide__empty', message);
  const detailLine = (label, value) => append(h('div'), h('dt', '', label), h('dd', '', value));
  const byHandle = list => new Map(list.map(item => [item.handle, item]));

  function start(data) {
    const entries = byHandle(data.entries);
    const families = byHandle(data.families);
    const pathways = byHandle(data.pathways);
    const comparisons = byHandle(data.comparisons);
    const selected = (type, list) => list.get(params.get(type) || '');
    const mountBreadcrumb = parts => {
      const nav = h('nav', 'jootti-field-guide__breadcrumbs');
      nav.setAttribute('aria-label', 'Breadcrumb');
      const list = h('ol');
      parts.forEach((part, index) => {
        const item = h('li');
        if (part.route) item.append(link(part.label, part.route, part.extra || {}, ''));
        else {
          const current = h('span', '', part.label);
          if (index === parts.length - 1) current.setAttribute('aria-current', 'page');
          item.append(current);
        }
        list.append(item);
      });
      nav.append(list);
      view.prepend(nav);
    };
    const cards = (items, host, limit = 12) => {
      let shown = 0;
      const more = h('button', 'jootti-field-guide__more', 'Show more');
      more.type = 'button';
      function add() {
        items.slice(shown, shown + limit).forEach(item => host.append(card(item)));
        shown = Math.min(items.length, shown + limit);
        more.hidden = shown >= items.length;
      }
      more.addEventListener('click', add);
      add();
      if (items.length > limit) host.after(more);
    };
    const card = item => {
      const article = h('article', 'jootti-field-guide__entry-card');
      append(article, image(item, 'card'), eyebrow(item.category || item.fishery || 'Field Guide'), h('h2', '', item.name), h('p', '', item.take || item.summary || ''), link('View guide ↗', 'entry', {entry: item.handle}));
      return article;
    };
    const result = item => {
      const article = h('article', 'jootti-field-guide__result');
      const copy = h('div', 'jootti-field-guide__result-copy');
      append(copy, eyebrow(item.category || item.fishery || 'Field Guide'), h('h2', '', item.name), h('p', '', item.take || item.summary || ''), link('View guide ↗', 'entry', {entry: item.handle}));
      append(article, image(item), copy);
      return article;
    };
    const take = text => text && append(h('section', 'jootti-field-guide__take'), eyebrow('JOOTTI TAKE'), h('p', '', text));
    const market = text => text && append(h('aside', 'jootti-field-guide__market-note'), eyebrow('MARKET NOTE'), h('p', '', text));

    function renderEntry(item) {
      if (!item) return unavailable();
      publish('field_guide_entry_view', {entry_handle: item.handle, family_handle: item.family});
      const hero = append(h('section', 'jootti-field-guide__entry-hero'), eyebrow([item.fishery, item.category].filter(Boolean).join(' / ')), h('h1', '', item.name), item.water && h('p', 'jootti-field-guide__subtle', item.water), image(item, 'entry', true));
      const body = h('div', 'jootti-field-guide__entry-body');
      append(body, append(h('section', 'jootti-field-guide__entry-lead'), eyebrow('JOOTTI TAKE'), h('p', '', item.fullTake || item.take || item.summary || '')));
      const commerce = h('section', 'jootti-field-guide__commerce');
      for (const choice of item.commerceLinks || []) {
        try {
          const destination = new URL(choice.url);
          if (destination.origin !== location.origin || !destination.pathname.startsWith('/products/')) continue;
          const action = h('a', 'jootti-field-guide__commerce-link', `${choice.label} ↗`);
          action.href = destination.href;
          action.dataset.productId = choice.productId;
          commerce.append(action);
        } catch (_) { /* An invalid destination must never become a buying action. */ }
      }
      if (commerce.childElementCount) body.append(commerce);
      const fits = h('dl', 'jootti-field-guide__fit-list');
      [['Fishery', item.fishery], ['Water', item.water], ['Presentation', item.presentation], ['Environment', item.environment], ['Intent', item.intent]].filter(([, value]) => value).forEach(([label, value]) => fits.append(detailLine(label, value)));
      append(body, h('h2', '', 'Where it fits'), fits);
      const specs = Object.entries(item.specs || {});
      if (specs.length) {
        const details = h('details', 'jootti-field-guide__disclosure');
        const summary = h('summary', '', 'Technical details');
        summary.append(h('span', '', '+'));
        const list = h('dl', 'jootti-field-guide__fit-list');
        specs.forEach(([key, value]) => list.append(detailLine(key.replace('_jp', ' · Japan').replace('_usa', ' · USA').replace('_', ' '), value)));
        append(details, summary, list);
        body.append(details);
      }
      append(body, market(item.marketCaveat));
      if (families.has(item.family)) body.append(link('Explore the family ↗', 'family', {family: item.family}));
      const related = data.comparisons.filter(comp => comp.entries.includes(item.handle)).slice(0, 4);
      if (related.length) {
        body.append(h('h2', '', 'Compare the decision'));
        related.forEach(comp => body.append(link(comp.title + ' ↗', 'comparison', {comparison: comp.handle}, 'jootti-field-guide__route-link')));
      }
      view.replaceChildren(hero, body);
    }

    function renderFamily(item) {
      if (!item) {
        const section = append(h('section', 'jootti-field-guide__catalog'), eyebrow('MODEL FAMILIES'), h('h1', '', 'Explore the families.'), h('p', 'jootti-field-guide__subtle', 'Fifty-six public model lines, each with an eligible guide entry.'));
        const host = h('div', 'jootti-field-guide__catalog-grid');
        data.families.forEach(family => {
          const article = h('article', 'jootti-field-guide__entry-card');
          const first = entries.get(family.members[0]);
          append(article, image(family.image.url || family.image.asset ? family : first || family, 'card'), eyebrow(`${family.members.length} ${family.members.length === 1 ? 'MODEL' : 'MODELS'}`), h('h2', '', family.name), h('p', '', family.statement || ''), link('Explore family ↗', 'family', {family: family.handle}));
          host.append(article);
        });
        append(section, host); view.replaceChildren(section);
        return;
      }
      publish('field_guide_family_view', {family_handle: item.handle});
      const members = item.members.map(handle => entries.get(handle)).filter(Boolean);
      const lead = append(h('section', 'jootti-field-guide__family-hero'), eyebrow('MODEL FAMILY'), h('h1', '', item.name), item.statement && h('p', 'jootti-field-guide__subtle', item.statement), image(item.image.url || item.image.asset ? item : members[0] || item, 'family', true));
      const lineup = h('section', 'jootti-field-guide__family-depth');
      append(lineup, eyebrow('MODEL LINEUP'), h('h2', '', 'Choose the right role.'), item.variants && h('p', 'jootti-field-guide__subtle', item.variants));
      const list = h('ul', 'jootti-field-guide__depth-list');
      members.forEach((entry, index) => {
        const row = h('li');
        const role = item.roles.find(value => value.handle === entry.handle);
        const copy = h('div');
        append(copy, h('h3', '', entry.name), h('p', 'jootti-field-guide__subtle', (role && [role.role, role.depth].filter(Boolean).join(' · ')) || entry.take || ''), link('Read guide ↗', 'entry', {entry: entry.handle}));
        append(row, eyebrow(String(index + 1).padStart(2, '0')), image(entry, 'depth'), copy);
        list.append(row);
      });
      lineup.append(list);
      const related = item.comparisons.map(handle => comparisons.get(handle)).filter(Boolean);
      if (related.length) {
        lineup.append(h('h2', '', 'Compare the models'));
        related.forEach(comp => lineup.append(link(comp.title + ' ↗', 'comparison', {comparison: comp.handle}, 'jootti-field-guide__route-link')));
      }
      view.replaceChildren(lead, take(item.take), lineup);
    }

    function renderPathway(item) {
      if (!item) return unavailable();
      publish('field_guide_pathway_select', {pathway_handle: item.handle});
      const members = item.members.map(handle => entries.get(handle)).filter(Boolean);
      const list = h('section', 'jootti-field-guide__pathway-results');
      members.forEach(entry => list.append(result(entry)));
      view.replaceChildren(intro(item.category || 'PATHWAY', item.label, item.description || `${members.length} verified guide ${members.length === 1 ? 'entry' : 'entries'} for this path.`), list);
    }

    function renderComparison(item) {
      if (!item) return unavailable();
      publish('field_guide_compare_view', {comparison_handle: item.handle});
      const [left, right] = item.entries.map(handle => entries.get(handle));
      if (!left || !right) return unavailable();
      const hero = append(h('section', 'jootti-field-guide__comparison-hero'), eyebrow('COMPARE THE DECISION'), h('h1', '', item.title), item.purpose && h('p', 'jootti-field-guide__subtle', item.purpose));
      const pair = h('div', 'jootti-field-guide__comparison-pair');
      [left, right].forEach(entry => append(pair, append(h('div'), image(entry, 'compare', true), h('h2', '', entry.name), link('Read guide ↗', 'entry', {entry: entry.handle}))));
      hero.append(pair);
      const differences = h('section', 'jootti-field-guide__differences');
      append(differences, h('h2', '', 'The useful differences'));
      const table = h('table');
      const caption = h('caption', '', 'Compare verified guide details');
      const thead = h('thead');
      const headings = ['Decision', left.name, right.name].map(text => { const th = h('th', '', text); th.scope = 'col'; return th; });
      append(thead, append(h('tr'), ...headings));
      const tbody = h('tbody');
      item.differences.forEach(diff => { const th = h('th', '', diff.label); th.scope = 'row'; append(tbody, append(h('tr'), th, h('td', '', diff.left), h('td', '', diff.right))); });
      append(table, caption, thead, tbody);
      differences.append(table);
      const familyLinks = [...new Set([left.family, right.family])].filter(handle => families.has(handle));
      const familyNav = familyLinks.length && h('nav', 'jootti-field-guide__comparison-families');
      if (familyNav) {
        familyNav.setAttribute('aria-label', 'Model families');
        familyLinks.forEach(handle => familyNav.append(link(`Explore ${families.get(handle).name} family ↗`, 'family', {family: handle})));
      }
      view.replaceChildren(hero, take(item.guidance), differences, market(item.marketCaveat), familyNav);
    }

    function renderCatalog() {
      const host = h('div', 'jootti-field-guide__catalog-grid');
      view.replaceChildren(append(h('section', 'jootti-field-guide__catalog'), eyebrow('FIELD GUIDE CATALOG'), h('h1', '', 'Study the lineup.'), h('p', 'jootti-field-guide__subtle', 'All 104 public guide entries, including models outside the 29 pathways.'), host));
      cards(data.entries, host, 16);
    }

    function renderSearch() {
      const section = append(h('section', 'jootti-field-guide__search'), eyebrow('FIELD GUIDE SEARCH'), h('h1', '', 'Find your lure.'), h('p', 'jootti-field-guide__subtle', 'Search by model, family, role, water, or presentation.'));
      const form = h('form');
      form.setAttribute('role', 'search');
      const label = h('label', '', 'Search the Field Guide');
      label.htmlFor = 'fg-search-input';
      const row = h('div');
      const input = h('input');
      input.id = 'fg-search-input'; input.type = 'search'; input.autocomplete = 'off'; input.placeholder = 'ONETEN, jerkbait, shallow'; input.value = params.get('q') || '';
      const submit = h('button', '', 'Search ↗'); submit.type = 'submit';
      append(row, input, submit); append(form, label, row);
      const status = h('p', 'jootti-field-guide__subtle'); status.setAttribute('aria-live', 'polite');
      const familyHost = h('div', 'jootti-field-guide__search-families');
      const host = h('div');
      append(section, form, status, familyHost, host); view.replaceChildren(section);
      const search = () => {
        const query = input.value.trim().toLowerCase();
        const terms = query.split(/\s+/).filter(Boolean);
        if (host.nextElementSibling?.classList.contains('jootti-field-guide__more')) host.nextElementSibling.remove();
        host.replaceChildren(); familyHost.replaceChildren();
        if (!terms.length) { status.textContent = 'Enter a model, role, or water condition.'; return; }
        const matchedFamilies = data.families.filter(family => terms.every(term => family.name.toLowerCase().includes(term))).slice(0, 4);
        if (matchedFamilies.length) {
          familyHost.append(eyebrow('MATCHING FAMILIES'));
          matchedFamilies.forEach(family => familyHost.append(link(`Explore ${family.name} family ↗`, 'family', {family: family.handle}, 'jootti-field-guide__route-link')));
        }
        const matches = data.entries.map((entry, index) => {
          const family = families.get(entry.family)?.name || '';
          const pathLabels = entry.pathways.map(handle => pathways.get(handle)?.label || '').join(' ');
          const haystack = [entry.name, family, entry.category, entry.water, entry.presentation, entry.environment, entry.intent, pathLabels].filter(Boolean).join(' ').toLowerCase();
          return {entry, index, score: terms.every(term => haystack.includes(term)) ? (entry.name.toLowerCase().includes(query) ? 0 : family.toLowerCase().includes(query) ? 1 : 2) : 99};
        }).filter(item => item.score < 99).sort((a,b) => a.score - b.score || a.index - b.index).map(item => item.entry);
        status.textContent = `${matches.length} verified ${matches.length === 1 ? 'entry' : 'entries'} found.`;
        publish('field_guide_search', {query_length: query.length, result_count: matches.length});
        if (matches.length) cards(matches, host, 12); else host.append(empty('No verified entries match. Try a model, family, or water condition.'));
      };
      form.addEventListener('submit', event => {
        event.preventDefault();
        const url = new URL(location.href);
        if (input.value.trim()) url.searchParams.set('q', input.value.trim()); else url.searchParams.delete('q');
        history.replaceState(null, '', url.pathname + url.search);
        search();
      });
      search();
    }

    function renderChoose() {
      publish('help_me_choose_start');
      const section = h('section', 'jootti-field-guide__choose');
      const state = {step: 0, fishery: '', water: '', intent: ''};
      const header = h('div', 'jootti-field-guide__choose-step');
      const options = h('div', 'jootti-field-guide__choose-options');
      const output = h('div');
      const controls = h('div', 'jootti-field-guide__choose-controls');
      const back = h('button', '', 'Back'); back.type = 'button';
      const next = h('button', '', 'Next ↗'); next.type = 'button';
      const status = h('p', 'jootti-field-guide__sr-only'); status.setAttribute('aria-live', 'polite');
      append(controls, back, next); append(section, header, options, output, controls, status); view.replaceChildren(section);
      const choices = () => {
        if (state.step === 0) return [['Bass', 'Depth and presentation.'], ['Trout', 'Current and stream presentation.']];
        if (state.step === 1) return [['any', 'Any water condition'], ...data.pathways.filter(path => ['Water Column','Environment'].includes(path.category) && path.members.some(handle => entries.get(handle)?.fishery === state.fishery)).map(path => [path.handle, path.label])];
        return [['any', 'Any presentation'], ...data.pathways.filter(path => ['Presentation','Intent'].includes(path.category) && path.members.some(handle => entries.get(handle)?.fishery === state.fishery)).map(path => [path.handle, path.label])];
      };
      const match = () => {
        let candidates = data.entries.filter(entry => entry.fishery === state.fishery);
        const exact = candidates.filter(entry => (state.water === 'any' || entry.pathways.includes(state.water)) && (state.intent === 'any' || entry.pathways.includes(state.intent)));
        let fallback = false;
        if (exact.length) candidates = exact;
        else {
          fallback = true;
          candidates = candidates.filter(entry => state.water === 'any' || entry.pathways.includes(state.water));
          if (!candidates.length) candidates = data.entries.filter(entry => entry.fishery === state.fishery);
        }
        output.replaceChildren(eyebrow('HELP ME CHOOSE / VERIFIED FITS'), h('h1', '', 'For the water ahead.'), h('p', 'jootti-field-guide__subtle', fallback ? 'No exact intersection exists. These are the closest verified fits for your fishery and water choice.' : 'These guide entries match your selected pathways.'));
        const host = h('div'); output.append(host);
        candidates.slice(0, 6).forEach(entry => host.append(result(entry)));
        publish('help_me_choose_complete', {fishery: state.fishery, water_pathway: state.water, presentation_pathway: state.intent, result_count: candidates.length});
        if (!candidates.length) output.append(empty('No verified fit. Browse the catalog or change a choice.'));
        output.append(link('Browse all guide entries ↗', 'catalog'));
      };
      const update = () => {
        const titles = ['Where do you fish?', 'What is the water doing?', 'What do you need the lure to do?'];
        header.replaceChildren(); options.replaceChildren(); output.replaceChildren();
        back.hidden = state.step === 0;
        next.hidden = state.step === 3;
        options.hidden = state.step === 3;
        if (state.step === 3) { match(); status.textContent = 'Verified recommendations'; return; }
        append(header, eyebrow(`HELP ME CHOOSE / 0${state.step + 1} OF 03`), h('h1', '', titles[state.step]), h('p', 'jootti-field-guide__subtle', 'Choose what you know. We will show only verified guide entries.'));
        const current = state.step === 0 ? state.fishery : state.step === 1 ? state.water : state.intent;
        choices().forEach(([value, label]) => {
          const button = h('button', 'jootti-field-guide__choose-option'); button.type = 'button'; button.dataset.value = value; button.setAttribute('aria-pressed', String(current === value));
          append(button, append(h('span'), h('strong', '', state.step === 0 ? value : label), state.step === 0 && h('small', '', label)), h('span', '', '↗'));
          button.addEventListener('click', () => {
            if (state.step === 0) { state.fishery = value; state.water = ''; state.intent = ''; }
            else if (state.step === 1) { state.water = value; state.intent = ''; }
            else state.intent = value;
            update();
          });
          options.append(button);
        });
        next.disabled = !current;
        status.textContent = `Step ${state.step + 1} of 3`;
      };
      next.addEventListener('click', () => { if (next.disabled) return; publish('help_me_choose_step', {step: state.step + 1, fishery: state.fishery, water_pathway: state.water, presentation_pathway: state.intent}); state.step++; update(); const heading = header.querySelector('h1') || output.querySelector('h1'); if (heading) { heading.tabIndex = -1; heading.focus(); } });
      back.addEventListener('click', () => { state.step = Math.max(0, state.step - 1); update(); });
      update();
    }

    function unavailable() { view.replaceChildren(intro('FIELD GUIDE', 'Guide route unavailable.', 'Choose a verified entry from the catalog.'), link('Open catalog ↗', 'catalog')); }
    const home = {label: 'Field Guide', route: 'landing'};
    if (screen === 'entry') {
      const item = selected('entry', entries);
      renderEntry(item);
      if (item) mountBreadcrumb([home, {label: 'Families', route: 'family'}, {label: families.get(item.family)?.name || 'Family', route: 'family', extra: {family: item.family}}, {label: item.name}]);
    } else if (screen === 'family') {
      const item = selected('family', families);
      renderFamily(item);
      mountBreadcrumb([home, ...(item ? [{label: 'Families', route: 'family'}, {label: item.name}] : [{label: 'Families'}])]);
    } else if (screen === 'pathway') {
      const item = selected('pathway', pathways);
      renderPathway(item);
      if (item) mountBreadcrumb([home, {label: item.category}, {label: item.label}]);
    } else if (screen === 'comparison') {
      const item = selected('comparison', comparisons);
      renderComparison(item);
      if (item) mountBreadcrumb([home, {label: 'Compare'}, {label: item.title}]);
    } else if (screen === 'catalog') { renderCatalog(); mountBreadcrumb([home, {label: 'Catalog'}]); }
    else if (screen === 'search') { renderSearch(); mountBreadcrumb([home, {label: 'Search'}]); }
    else if (screen === 'choose') { renderChoose(); mountBreadcrumb([home, {label: 'Help me choose'}]); }
    else unavailable();
  }

  fetch(root.dataset.fgDataUrl, {credentials: 'same-origin'})
    .then(response => { if (!response.ok) throw Error(`Guide data ${response.status}`); return response.json(); })
    .then(data => {
      if (data.entries?.length !== 104 || data.families?.length !== 56 || data.pathways?.length !== 29 || data.comparisons?.length !== 24) throw Error('Guide data count mismatch');
      start(data);
    })
    .catch(() => view.replaceChildren(intro('FIELD GUIDE', 'Guide temporarily unavailable.', 'Please return to the landing page and try again.'), link('Back to guide ↗', 'landing')));
})();
